import {Card} from "@material-ui/core";
import {CreateProps} from "react-admin";
import {CustomCreate} from "../../components/CustomCreate";
import {UserCarrierForm} from "./UserCarrierForm";

export const UserCarrierCreate = (props: CreateProps) => {
  return (
    <CustomCreate {...props} component={Card}>
      <UserCarrierForm />
    </CustomCreate>
  );
};
